export const makeAccordion = (titleClassName: string) => {
  const handleClick = (e: any) => {
    e.preventDefault();
    e.target.closest("tr").classList.toggle("hidden");
  };

  const accordionTitles = document.querySelectorAll(`.${titleClassName}`);

  accordionTitles.forEach(title => {
    if (title && title !== null) {
      // @ts-ignore
      title.closest("tr").classList.toggle("hidden");
      title.addEventListener("click", handleClick);
    }
  });
};
